import { isEU } from "../Functions/functions";

const getModelPrice = (model, loggedInUser, order = null) => {
    if (order === null) {
        return getModelPriceWithoutOrder(model, loggedInUser);
    }

    const isLegacyPricingV1 = Number(order?.pricing_version ?? 0) === 1;
    if (!isLegacyPricingV1) {
        if (/[a-z]/i.test(model?.pivot?.price)) {
            return <>{model.pivot.price}</>;
        }

        const baseTotal = parseFloat(model?.pivot?.price ?? 0) * parseInt(model?.pivot?.amount ?? 0);
        const hasBackendDiscountPrice =
            model?.pivot?.discount_price !== null &&
            typeof model?.pivot?.discount_price !== "undefined" &&
            model?.pivot?.discount_price !== "undefined";
        const finalTotal = hasBackendDiscountPrice ? parseFloat(model.pivot.discount_price) : baseTotal;

        if (
            Number.isFinite(baseTotal) &&
            Number.isFinite(finalTotal) &&
            baseTotal.toFixed(2) !== finalTotal.toFixed(2)
        ) {
            return (
                <>
                    <s>€{baseTotal.toFixed(2)}</s>
                    <br />€{finalTotal.toFixed(2)}
                </>
            );
        }

        return (
            <>
                {<>€</>}
                {(Number.isFinite(finalTotal) ? finalTotal : 0).toFixed(2)}
            </>
        );
    }

    if (order.lock_order_prices === true) {
        return (
            <>
                {<>€</>}
                {parseFloat(model.pivot.price * model.pivot.amount).toFixed(2)}
            </>
        );
    }

    if (/[a-z]/i.test(model.pivot.price)) {
        return <>{model.pivot.price}</>;
    } else if (order.discount !== null && order.discount > 0) {
        let discount = 0;
        let modelPrice = (parseFloat(model.pivot.price) * model.pivot.amount).toFixed(2);

        if (model.admin_edited) {
            return (
                <>
                    <s>€{parseFloat(model.discount_price).toFixed(2)}</s>
                </>
            );
        }

        if (
            loggedInUser?.company?.price_settings !== null &&
            loggedInUser?.company?.price_settings.allow_staffel_discount == true &&
            order.status === "quotation"
        ) {
            let originalPrice = parseFloat(model.pivot.price) * model.pivot.amount;
            modelPrice -= originalPrice - originalPrice * parseFloat(model.pivot.discount_multiplier);
            modelPrice = modelPrice.toFixed(2);
        } else if (order.status !== "quotation") {
            if (model.pivot.discount_price !== null && model.pivot.discount_price !== "undefined") {
                // Backend already determined correct price (staffel skipped if price range override was active)
                modelPrice = parseFloat(model.pivot.discount_price).toFixed(2);
            } else {
                let originalPrice = parseFloat(model.pivot.price) * model.pivot.amount;
                let withStaffel = originalPrice * parseFloat(model.pivot.discount_multiplier);
                if (originalPrice !== withStaffel) {
                    modelPrice = withStaffel.toFixed(2);
                }
            }
        }

        if (modelPrice < 0) {
            modelPrice = (0).toFixed(2);
        }

        if (
            order.fixed_discount === false &&
            (parseFloat(model.pivot.price) * model.pivot.amount).toFixed(2) !== modelPrice
        ) {
            return (
                <>
                    <s>
                        {<>€</>}
                        {(parseFloat(model.pivot.price) * model.pivot.amount).toFixed(2)}
                    </s>
                    <br />
                    {<>€</>}
                    {modelPrice}
                </>
            );
        } else if (
            loggedInUser?.company?.price_settings !== null &&
            loggedInUser?.company?.price_settings.allow_staffel_discount == true &&
            (parseFloat(model.pivot.price) * model.pivot.amount * model.pivot.discount_multiplier).toFixed(2) !==
                modelPrice &&
            order.status === "quotation"
        ) {
            return (
                <>
                    <s>
                        {<>€</>}
                        {(parseFloat(model.pivot.price) * model.pivot.amount).toFixed(2)}
                    </s>
                    <br />
                    {<>€</>}
                    {modelPrice}
                </>
            );
        } else {
            if (
                !/[a-z]/i.test(model.pivot.price) &&
                parseFloat(modelPrice) !== parseFloat(model.pivot.price * model.pivot.amount) &&
                order.status !== "quotation"
            ) {
                return (
                    <>
                        <s>€{parseFloat(model.pivot.price * model.pivot.amount).toFixed(2)}</s>
                        <br />€{modelPrice}
                    </>
                );
            } else {
                return (
                    <>
                        {<>€</>}
                        {modelPrice}
                    </>
                );
            }
        }
    } else if (typeof order.discounts !== "undefined" && order.discounts.length > 0) {
        let modelPrice = 0;
        if (
            typeof model.pivot.discount_price !== "undefined" &&
            model.pivot.discount_price !== null &&
            order.discounts[0].fixed == false &&
            parseFloat(model.pivot.discount_price).toFixed(2) !==
                (parseFloat(model.pivot.price) * model.pivot.amount).toFixed(2)
        ) {
            modelPrice = parseFloat(model.pivot.discount_price);
            return (
                <>
                    <s>€{(parseFloat(model.pivot.price) * model.pivot.amount).toFixed(2)}</s>
                    <br />€{parseFloat(model.pivot.discount_price).toFixed(2)}
                </>
            );
        } else {
            // Check if model price is a valid number (not a price 'on request')
            if (!/[a-z]/i.test(model.pivot.price)) {
                if (
                    model.pivot.price * model.pivot.amount !==
                    model.pivot.price * model.pivot.amount * model.pivot.discount_multiplier
                ) {
                    return (
                        <>
                            <s>€{parseFloat(model.pivot.price * model.pivot.amount).toFixed(2)}</s>
                            <br />€
                            {parseFloat(
                                model.pivot.price * model.pivot.amount * model.pivot.discount_multiplier
                            ).toFixed(2)}
                        </>
                    );
                }
                modelPrice = parseFloat(model.pivot.price * model.pivot.amount * model.pivot.discount_multiplier);
            } else {
                return <>{model.pivot.price}</>;
            }
        }

        if (
            !/[a-z]/i.test(model.pivot.price) &&
            model.pivot.price * model.pivot.amount !==
                model.pivot.price * model.pivot.amount * model.pivot.discount_multiplier
        ) {
            return (
                <>
                    <s>€{parseFloat(model.pivot.price * model.pivot.amount).toFixed(2)}</s>
                    <br />€
                    {parseFloat(model.pivot.price * model.pivot.amount * model.pivot.discount_multiplier).toFixed(2)}
                </>
            );
        } else {
            return (
                <>
                    {<>€</>}
                    {modelPrice.toFixed(2)}
                </>
            );
        }
    } else {
        let regularPrice = model.pivot.amount * model.pivot.price;
        let discountPrice = regularPrice;

        if (model.pivot.discount_price !== null && model.pivot.discount_price !== "undefined") {
            discountPrice = parseFloat(model.pivot.discount_price);
        }

        if (order.discount !== null && order.discount > 0 && order.fixed_discount === false) {
            discountPrice -= regularPrice - regularPrice * (order.discount / 100);
        }

        if (
            loggedInUser?.company?.price_settings !== null &&
            loggedInUser?.company?.price_settings.allow_staffel_discount == true &&
            order.status === "quotation" &&
            !(model.pivot.discount_price !== null && model.pivot.discount_price !== "undefined")
        ) {
            discountPrice -= regularPrice - regularPrice * model.pivot.discount_multiplier;
        }

        if (order.status !== "quotation") {
            discountPrice = regularPrice * model.pivot.discount_multiplier;
        }

        // format regular and discountprice to 2 decimal places
        const regularPriceFormatted = parseFloat(regularPrice).toFixed(2);
        const discountPriceFormatted = parseFloat(discountPrice).toFixed(2);

        if (regularPriceFormatted !== discountPriceFormatted) {
            return (
                <>
                    <s>€{regularPrice.toFixed(2)}</s>
                    <br />€{discountPrice.toFixed(2)}
                </>
            );
        } else {
            return (
                <>
                    {<>€</>}
                    {regularPrice.toFixed(2)}
                </>
            );
        }
    }
};

const getModelPriceWithoutOrder = (model, loggedInUser) => {
    if (/[a-z]/i.test(model.price)) {
        return <>{model.price}</>;
    }

    let regularPrice = model.amount * model.price;
    let discountPrice = regularPrice;

    if (typeof model.admin_edited !== "undefined" && model.admin_edited === true) {
        if (model.pivot.discount_price !== null) {
            return (
                <>
                    <s>&euro; {(parseFloat(model.pivot.price) * model.amount).toFixed(2)}</s>
                    <br />
                    <p className="price">&euro; {parseFloat(model.pivot.discount_price).toFixed(2)}</p>
                </>
            );
        } else {
            return (
                <>
                    <p className="price">&euro; {(parseFloat(model.pivot.price) * model.amount).toFixed(2)}</p>
                </>
            );
        }
    }

    if (
        typeof model.pivot !== "undefined" &&
        typeof model.pivot.discount_price !== "undefined" &&
        model.pivot.discount_price !== null
    ) {
        discountPrice = parseFloat(model.pivot.discount_price);
    } else if (
        loggedInUser?.company?.price_settings !== null &&
        loggedInUser?.company?.price_settings.allow_staffel_discount == true
    ) {
        discountPrice = regularPrice * model.discount_multiplier;
    }

    if (
        loggedInUser?.company?.price_settings !== null &&
        loggedInUser?.company?.price_settings.allow_staffel_discount == true &&
        regularPrice !== discountPrice
    ) {
        return (
            <>
                <s>
                    {!isNaN(regularPrice) && <>&euro;</>}
                    {!isNaN(regularPrice) && regularPrice.toFixed(2)}
                    {!isNaN(regularPrice) &&
                        typeof model.price === "string" &&
                        /[a-z]/i.test(regularPrice) &&
                        regularPrice}
                </s>
                <br />
                <p className="price">
                    {!isNaN(discountPrice) && <>&euro;</>}
                    {!isNaN(discountPrice) && discountPrice.toFixed(2)}
                    {!isNaN(discountPrice) &&
                        typeof model.price === "string" &&
                        /[a-z]/i.test(discountPrice) &&
                        discountPrice}
                    {typeof model.price === "string" && /[a-z]/i.test(model.price) && model.price}
                </p>
            </>
        );
    }

    return (
        <>
            {parseFloat(model.discount_multiplier) !== 1 &&
                !/[a-z]/i.test(model.price) &&
                parseFloat(model.price * model.amount) !== parseFloat(discountPrice) && (
                    <s>
                        {!isNaN(model.price) && <>€</>}
                        {!isNaN(model.price) && parseFloat(regularPrice).toFixed(2)}
                        {typeof model.price === "string" && /[a-z]/i.test(model.price) && model.price}
                    </s>
                )}
            <p className="price">
                {!isNaN(model.price) && <>&euro;</>}
                {!isNaN(discountPrice) && parseFloat(discountPrice).toFixed(2)}
                {typeof model.price === "string" && /[a-z]/i.test(model.price) && model.price}
            </p>
        </>
    );
};

const getShippingCosts = (order) => {
    let shippingCosts = 0;
    if (typeof order.delivery_price !== "undefined" && order.delivery_price !== null) {
        shippingCosts = parseFloat(order.delivery_price);
    }
    return shippingCosts;
};

const getCompanyDiscount = (
    order,
    loggedInUser,
    mandatoryProductSettings,
    onlyPercentages = false,
    productSettingsExclusions = []
) => {
    // No company discount if prices are locked
    if (order.lock_order_prices === true) {
        return 0;
    }

    let totalCompanyDiscount = 0;
    let subtotal = 0;
    const companyPriceSettings = loggedInUser.company?.price_settings;

    order.models.forEach((element) => {
        if (/[a-z]/i.test(element.pivot.price)) {
            // nothing if the price is on request
        } else if (element.pivot.discount_price !== "undefined" && element.pivot.discount_price !== null) {
            subtotal += parseFloat(element.pivot.discount_price);
        } else if (
            companyPriceSettings &&
            companyPriceSettings.allow_staffel_discount == true &&
            order.status === "quotation"
        ) {
            subtotal += parseFloat(element.pivot.price * element.pivot.amount) * element.pivot.discount_multiplier;
        } else if (!/[a-z]/i.test(element.pivot.price)) {
            subtotal += parseFloat(element.pivot.price * element.pivot.amount);
        }
    });

    order.products.forEach((element) => {
        if (element.line_total !== undefined && element.line_total !== null) {
            subtotal += parseFloat(element.line_total);
        } else {
            const multiplier =
                order.lock_order_prices || element.admin_edited ? 1 : parseFloat(element.discount_multiplier ?? 1);
            subtotal += parseFloat(element.price) * multiplier * parseInt(element.quantity);
        }
    });

    if (getExtraCosts(order, mandatoryProductSettings, productSettingsExclusions) !== false) {
        subtotal += parseFloat(getExtraCosts(order, mandatoryProductSettings, productSettingsExclusions));
    }

    // Get manual extra costs (from admin panel)
    order.extraCosts.forEach((element) => {
        if (element.name !== null && element.name.includes("Company discount")) {
            subtotal += parseFloat(element.price);
            totalCompanyDiscount += Math.abs(parseFloat(element.price));
        }
    });

    // Check if quotation and minimum order amount is set
    if (order.status === "quotation" && companyPriceSettings && companyPriceSettings.minimum_order_amount > subtotal) {
        subtotal = companyPriceSettings.minimum_order_amount;
    }

    if (totalCompanyDiscount > 0) {
        return totalCompanyDiscount;
    }

    subtotal -= parseFloat(getDiscountCodesAmount(order, mandatoryProductSettings, true));

    if (order?.minimum_order_amount !== null && order?.minimum_order_amount > 0) {
        subtotal += parseFloat(order?.minimum_order_amount);
    }

    if (typeof order.discount !== "undefined" && order.discount !== null) {
        if (order.fixed_discount) {
            return parseFloat(order.discount);
        } else {
            return parseFloat(subtotal * (order.discount / 100));
        }
    } else {
        if (companyPriceSettings && companyPriceSettings.discount > 0 && companyPriceSettings.fixed_discount === true) {
            if (order.status === "quotation") {
                return parseFloat(companyPriceSettings.discount);
            } else {
                return 0;
            }
        } else if (
            companyPriceSettings &&
            companyPriceSettings.discount > 0 &&
            companyPriceSettings.fixed_discount === false &&
            order.status === "quotation"
        ) {
            return parseFloat(subtotal * (companyPriceSettings.discount / 100));
        }
    }

    return totalCompanyDiscount;
};

const getOrderDiscount = (order, productSettingsExclusions = []) => {
    // No company discount if prices are locked
    if (order.lock_order_prices === true) {
        return 0;
    }

    if (order.fixed_discount) {
        return parseFloat(order.discount);
    } else {
        return parseFloat(
            getSubtotalPrice(order, null, null, null, null, productSettingsExclusions) *
                (parseFloat(order.discount) / 100)
        );
    }
};

const getDiscountCodesAmount = (
    order,
    mandatoryProductSettings,
    withFixedDiscounts = false,
    productSettingsExclusions = []
) => {
    if (order.discounts === null || order.discounts.length === 0 || order.lock_order_prices === true) {
        return 0;
    }
    let subtotal = 0;
    let total = 0;
    order.models.forEach((element) => {
        if (/[a-z]/i.test(element.pivot.price)) {
            // nothing if the price is on request
        } else if (element.pivot.discount_price !== "undefined" && element.pivot.discount_price !== null) {
            subtotal += parseFloat(element.pivot.discount_price);
        } else if (!/[a-z]/i.test(element.pivot.price)) {
            subtotal += parseFloat(element.pivot.price * element.pivot.amount);
        }
    });

    order.products.forEach((element) => {
        if (element.line_total !== undefined && element.line_total !== null) {
            subtotal += parseFloat(element.line_total);
        } else {
            const multiplier =
                order.lock_order_prices || element.admin_edited ? 1 : parseFloat(element.discount_multiplier ?? 1);
            subtotal += parseFloat(element.price) * multiplier * parseInt(element.quantity);
        }
    });

    // Add manual extra costs
    order.extraCosts.forEach((element) => {
        if (element.price > 0 && !element.name.includes("Minimum order amount")) {
            subtotal += parseFloat(element.price);
        }
    });

    if (order?.minimum_order_amount !== null && order?.minimum_order_amount > 0) {
        subtotal += parseFloat(order?.minimum_order_amount);
    }

    subtotal += parseFloat(getExtraCosts(order, mandatoryProductSettings, productSettingsExclusions));
    order.discounts.forEach((discount) => {
        if (discount.fixed) {
            // if (withFixedDiscounts) {
            //     total += parseFloat(discount.discount);
            // } else {
            //     total += 0; // Added as extra cost
            // }
            total += parseFloat(discount.discount);
        } else {
            total += parseFloat(subtotal) * (parseFloat(discount.discount) / 100);
        }
    });
    return total;
};

const getTotalPrice = (
    order,
    loggedInUser,
    setTotalDiscount = () => {},
    mandatoryProductSettings,
    productSettings,
    productSettingsExclusions = []
) => {
    let totalDiscount = 0;
    let originalTotal = 0;
    let originalTotalWithStaffel = 0;

    if (
        typeof order === "undefined" ||
        order === null ||
        typeof mandatoryProductSettings === "undefined" ||
        mandatoryProductSettings === null
    ) {
        return 0;
    }
    order.models.forEach((element) => {
        if (order.lock_order_prices === true) {
            originalTotal += parseFloat(element.pivot.price) * element.pivot.amount;
            originalTotalWithStaffel += parseFloat(element.pivot.price) * element.pivot.amount;
        } else if (/[a-z]/i.test(element.pivot.price)) {
            // nothing if the price is on request
        } else if (
            loggedInUser?.company?.price_settings !== null &&
            loggedInUser?.company?.price_settings.discount > 0
        ) {
            let discount = 0;
            originalTotal += parseFloat(element.pivot.price) * element.pivot.amount;
            originalTotalWithStaffel +=
                parseFloat(element.pivot.price) * element.pivot.amount * element.pivot.discount_multiplier;
            if (typeof order.discount === "undefined" || order.discount === null) {
                if (loggedInUser?.company?.price_settings.fixed_discount === false) {
                    discount =
                        parseFloat(element.pivot.price) *
                        element.pivot.amount *
                        (parseFloat(loggedInUser?.company?.price_settings.discount) / 100);
                }
            } else {
                if (order.fixed_discount === false) {
                    discount =
                        parseFloat(element.pivot.price) * element.pivot.amount * (parseFloat(order.discount) / 100);
                }
            }

            let originalPrice = parseFloat(element.pivot.price) * element.pivot.amount;
            if (
                loggedInUser?.company?.price_settings !== null &&
                loggedInUser?.company?.price_settings.allow_staffel_discount == true
            ) {
                discount += originalPrice - originalPrice * parseFloat(element.pivot.discount_multiplier);
            }

            totalDiscount += parseFloat(discount);
        } else if (element.pivot.discount_price !== "undefined" && element.pivot.discount_price !== null) {
            if (order.discounts.length > 0) {
                if (typeof element.pivot.discount_price !== "undefined" && element.pivot.discount_price !== null) {
                    let discount = 0;
                    let regularPrice = parseFloat(element.pivot.price * element.pivot.amount);
                    originalTotalWithStaffel +=
                        parseFloat(element.pivot.price) * element.pivot.amount * element.pivot.discount_multiplier;
                    let quantityDiscount = regularPrice - regularPrice * element.pivot.discount_multiplier;
                    totalDiscount += parseFloat(quantityDiscount);

                    if (order.discounts[0].fixed === false) {
                        discount =
                            parseFloat(element.pivot.price) *
                            element.pivot.amount *
                            parseFloat(order.discounts[0].discount / 100);
                    }
                    totalDiscount += parseFloat(discount);
                    originalTotal += parseFloat(regularPrice);
                } else {
                    // Check if model price is a valid number (not a price 'on request')
                    if (!/[a-z]/i.test(element.pivot.price)) {
                        let discount = 0;
                        if (order.discounts[0].fixed === false) {
                            discount =
                                parseFloat(element.pivot.price) *
                                element.pivot.amount *
                                parseFloat(order.discounts[0].discount / 100);
                        }
                        totalDiscount += parseFloat(discount);
                    }
                }
            } else {
                let regularPrice = parseFloat(element.pivot.price * element.pivot.amount);
                totalDiscount += parseFloat(regularPrice - parseFloat(element.pivot.discount_price));
                originalTotal += (parseFloat(element.pivot.price) * element.pivot.amount).toFixed(2);
                originalTotalWithStaffel += parseFloat(element.pivot.price) * element.pivot.amount;
            }
        } else {
            let regularPrice = parseFloat(element.pivot.price * element.pivot.amount);
            totalDiscount += parseFloat(regularPrice - parseFloat(element.pivot.discount_price));
            originalTotal += (parseFloat(element.pivot.price) * element.pivot.amount).toFixed(2);
            originalTotalWithStaffel += parseFloat(element.pivot.price) * element.pivot.amount;
        }
    });
    let total = parseFloat(
        getSubtotalPrice(order, loggedInUser, mandatoryProductSettings, false, productSettingsExclusions)
    );
    total += getMinimumOrderCosts(order, loggedInUser, mandatoryProductSettings, productSettingsExclusions);

    let companyDiscount = getCompanyDiscount(
        order,
        loggedInUser,
        mandatoryProductSettings,
        true,
        productSettingsExclusions
    );
    total -= parseFloat(companyDiscount);

    let discountCodesAmount = getDiscountCodesAmount(order, mandatoryProductSettings, true, productSettingsExclusions);
    total -= parseFloat(discountCodesAmount);

    if (total < 0) {
        total = 0;
    }

    order.extraCosts.forEach((element) => {
        if (
            element.name !== null &&
            !element.name.includes("Discount code") &&
            !element.name.includes("Company discount") &&
            !element.name.includes("Minimum order amount")
        ) {
            total += parseFloat(element.price);
        } else if (element.name === null) {
            total += parseFloat(element.price);
        }
    });

    //Company discount
    if (
        loggedInUser?.company?.price_settings !== null &&
        loggedInUser?.company?.price_settings.discount > 0 &&
        loggedInUser?.company?.price_settings.fixed_discount === true &&
        order.status === "quotation"
    ) {
        totalDiscount += parseFloat(loggedInUser?.company?.price_settings.discount);
    } else if (order.discount !== null && order.fixed_discount === true && order.status !== "quotation") {
        totalDiscount += parseFloat(order.discount);
    }

    if (order.discounts.length > 0) {
        if (order.discounts[0].fixed == false) {
            let discount = parseFloat(order.discounts[0].discount);
            totalDiscount += parseFloat(originalTotalWithStaffel * discount) / 100;
        } else {
            let discount = parseFloat(order.discounts[0].discount);
            totalDiscount += parseFloat(discount);
        }
    }

    let shippingCosts = getShippingCosts(order);
    if (total < 0) {
        total = 0;
        // Add shipping costs again
        if (shippingCosts !== "..." && typeof shippingCosts !== "undefined" && shippingCosts !== null) {
            total += parseFloat(shippingCosts);
        }
    } else if (shippingCosts !== "..." && typeof shippingCosts !== "undefined" && shippingCosts !== null) {
        total += parseFloat(shippingCosts);
    }
    total += calculateVat(
        order,
        loggedInUser,
        mandatoryProductSettings,
        productSettings,
        null,
        null,
        null,
        null,
        null,
        productSettingsExclusions
    );
    // Set discount amount
    if (
        (loggedInUser?.company?.price_settings !== null && loggedInUser?.company?.price_settings.discount > 0) ||
        loggedInUser?.company?.price_settings === null ||
        (loggedInUser?.company?.price_settings !== null &&
            loggedInUser?.company?.price_settings.allow_staffel_discount != false &&
            totalDiscount > 0)
    ) {
        setTotalDiscount(parseFloat(totalDiscount).toFixed(2));
    } else if (typeof order.discount !== "undefined" && order.discount !== null && order.discount !== 0) {
        setTotalDiscount(parseFloat(totalDiscount).toFixed(2));
    } else if (order.discounts.length > 0) {
        setTotalDiscount(parseFloat(totalDiscount).toFixed(2));
    }

    return total.toFixed(2);
};

const getSubtotalPrice = (
    order,
    loggedInUser,
    mandatoryProductSettings,
    withExtraCosts = false,
    productSettingsExclusions = []
) => {
    let total = 0;

    if (
        typeof order === "undefined" ||
        order === null ||
        typeof mandatoryProductSettings === "undefined" ||
        mandatoryProductSettings === null
    ) {
        return 0;
    }

    order.models.forEach((element) => {
        if (order.lock_order_prices === true) {
            total += parseFloat(element.pivot.price * element.pivot.amount);
        } else if (element.admin_edited) {
            total +=
                element.pivot.discount_price !== null
                    ? parseFloat(element.pivot.discount_price)
                    : parseFloat(element.pivot.price * element.pivot.amount);
        } else if (/[a-z]/i.test(element.pivot.price)) {
            // nothing if the price is on request
        } else if (element.pivot.discount_price !== "undefined" && element.pivot.discount_price !== null) {
            total += parseFloat(element.pivot.discount_price);
        } else if (
            loggedInUser?.company?.price_settings !== null &&
            loggedInUser?.company?.price_settings.allow_staffel_discount == true &&
            order.status === "quotation"
        ) {
            total += parseFloat(element.pivot.price * element.pivot.amount) * element.pivot.discount_multiplier;
        } else if (!/[a-z]/i.test(element.pivot.price)) {
            total += parseFloat(element.pivot.price * element.pivot.amount);
        }
    });

    //Get mandatory options costs
    if (getExtraCosts(order, mandatoryProductSettings, productSettingsExclusions) !== false) {
        total += parseFloat(getExtraCosts(order, mandatoryProductSettings, productSettingsExclusions));
    }

    // Get manual extra costs (from admin panel)
    // Only shown visually. For calculations we don't add these yet.
    if (withExtraCosts !== false) {
        order.extraCosts.forEach((element) => {
            if (
                element.name !== null &&
                !element.name.includes("Discount code") &&
                !element.name.includes("Company discount") &&
                !element.name.includes("Minimum order amount")
            ) {
                total += parseFloat(element.price);
            } else if (element.name === null) {
                total += parseFloat(element.price);
            }
        });
    }

    // Add library products
    const products = order.products;
    if (typeof products !== "undefined" && products !== null) {
        products.forEach((element) => {
            if (element.line_total !== undefined && element.line_total !== null) {
                total += parseFloat(element.line_total);
            } else {
                const multiplier =
                    order.lock_order_prices || element.admin_edited ? 1 : parseFloat(element.discount_multiplier ?? 1);
                total += parseFloat(element.price) * multiplier * parseInt(element.quantity);
            }
        });
    }

    if (total < 0) {
        total = 0;
    }

    if (order?.minimum_order_amount !== null && order?.minimum_order_amount > 0) {
        total += parseFloat(order?.minimum_order_amount);
    }

    return total.toFixed(2);
};

const getExtraCosts = (order, mandatoryProductSettings, productSettingsExclusions = []) => {
    let result = 0;
    let checked = [];
    let checkedMedicals = [];

    if (
        typeof order === "undefined" ||
        order === null ||
        typeof mandatoryProductSettings === "undefined" ||
        mandatoryProductSettings === null
    ) {
        return 0;
    }

    order.models.forEach((model) => {
        mandatoryProductSettings.forEach((setting) => {
            if (model.settings?.application === setting?.application) {
                if (
                    setting.application === "Dental" &&
                    model.settings.intendedUse &&
                    model.settings.intendedUse.includes("Short term")
                ) {
                    // skip this model, no need for extra costs
                    return;
                }

                // First check the custom settings set from admin, then defaults
                productSettingsExclusions.forEach((exclusion) => {
                    // Check if application is same
                    if (!checked.includes(setting.application) && exclusion.application === setting.application) {
                        // Check if certificate of conformity is on and price is set
                        if (
                            exclusion.certificate_of_conformity === true &&
                            exclusion.certificate_of_conformity_cost !== null
                        ) {
                            result += parseFloat(exclusion.certificate_of_conformity_cost);
                            checked.push(setting.application);
                        }
                    }
                });

                if (
                    (!checked.includes(setting.application) ||
                        (!checkedMedicals.includes(model.settings.case) &&
                            typeof model.settings.case !== "undefined" &&
                            model.settings.case !== null)) &&
                    setting.application === "Medical" &&
                    (model.settings.sterile === "true" || model.settings.sterile === true)
                ) {
                    result += setting.mandatory_options[0].price;
                    checked.push(setting.application);
                    if (model.settings.case !== null && typeof model.settings.case !== "undefined") {
                        checkedMedicals.push(model.settings.case);
                    }
                } else if (setting.application !== "Medical" && !checked.includes(setting.application)) {
                    result += setting.mandatory_options[0].price;
                    checked.push(setting.application);
                }
            }
        });
    });

    return result.toFixed(2);
};

const getExtraOrderCosts = (order, mandatoryProductSettings, textData, productSettingsExclusions) => {
    let counter = 0;
    let manualCosts = order.extraCosts.map((element) => {
        counter++;
        if (element.name === null && element.description !== null) {
            return (
                <div key={counter}>
                    <p>{element.description}</p>
                    <p>€ {element.price}</p>
                </div>
            );
        } else if (
            element.name !== null &&
            !element.name.includes("Discount code") &&
            !element.name.includes("Company discount")
        ) {
            return (
                <div key={counter}>
                    <p>{element.name}</p>
                    <p>€ {element.price}</p>
                </div>
            );
        }
    });

    function parseDutchDate(dateString) {
        // Handles "28-04-2025 13:47:26" or "30-05-2025"
        try {
            const [datePart, timePart = "00:00:00"] = dateString.split(" ");
            const [day, month, year] = datePart.split("-");
            return new Date(`${year}-${month}-${day}T${timePart}`);
        } catch (error) {
            return new Date(); // Fallback to current date if parsing fails
        }
    }

    let checked = [];
    let mandatoryCosts = [];
    let checkedMedicals = [];
    order.models.forEach((model) => {
        mandatoryProductSettings.forEach((setting) => {
            if (model?.settings?.application === setting?.application) {
                if (
                    setting.application === "Dental" &&
                    model.settings.intendedUse &&
                    model.settings.intendedUse.includes("Short term")
                ) {
                    // skip this model, no need for extra costs
                    return;
                }

                // if order is older than 30-05-2025, use old price (35)
                if (parseDutchDate(order.orderDate) < new Date("2025-06-16")) {
                    setting.mandatory_options[0].price = 35;
                }

                // First check the custom settings set from admin, then defaults
                productSettingsExclusions.forEach((exclusion) => {
                    // Check if application is same
                    if (
                        !checked.includes(setting.application) &&
                        exclusion.application === setting.application &&
                        !(parseDutchDate(order.orderDate) < new Date("2025-06-16"))
                    ) {
                        // Check if certificate of conformity is on and price is set
                        if (
                            exclusion.certificate_of_conformity === true &&
                            exclusion.certificate_of_conformity_cost !== null
                        ) {
                            checked.push(setting.application);
                            mandatoryCosts.push({
                                application: setting.application,
                                price: parseFloat(exclusion.certificate_of_conformity_cost),
                            });
                        }
                    }
                });

                if (
                    (!checked.includes(setting.application) &&
                        setting.application === "Medical" &&
                        (model.settings.sterile === "true" || model.settings.sterile === true)) ||
                    (!checkedMedicals.includes(model.settings.case) &&
                        typeof model.settings.case !== "undefined" &&
                        model.settings.case !== null &&
                        model.settings.case !== "-")
                ) {
                    mandatoryCosts.push({
                        application: setting.application,
                        price: setting.mandatory_options[0].price,
                    });
                    checked.push(setting.application);
                    if (model.settings.case !== null && typeof model.settings.case !== "undefined") {
                        checkedMedicals.push(model.settings.case);
                    }
                } else if (setting.application !== "Medical" && !checked.includes(setting.application)) {
                    checked.push(setting.application);
                    mandatoryCosts.push({
                        application: setting.application,
                        price: setting.mandatory_options[0].price,
                    });
                }
            }
        });
    });

    let mandatoryCostsResult = mandatoryCosts.map((element) => {
        counter++;
        return (
            <div key={counter}>
                <p>
                    {textData["popups/order_overview"]["one_time_fee"]}: {element.application}
                </p>
                <p>€ {element.price.toFixed(2)}</p>
            </div>
        );
    });

    let result = [...manualCosts, ...mandatoryCostsResult];
    result = result.filter((element) => element !== undefined);

    return result;
};

const calculateVat = (
    order,
    loggedInUser,
    mandatoryProductSettings,
    productSettings,
    country = null,
    deliveryPrice = null,
    subtotal = null,
    companyDiscount = null,
    totalDiscountCodeAmount = null,
    productSettingsExclusions = []
) => {
    // Calc subtotal
    const getSubtotal = (
        order,
        loggedInUser,
        mandatoryProductSettings,
        productSettings,
        deliveryPrice = null,
        subtotal = null,
        companyDiscount = null,
        totalDiscountCodeAmount = null
    ) => {
        if (order !== null) {
            let subtotal = parseFloat(
                getSubtotalPrice(order, loggedInUser, mandatoryProductSettings, false, productSettingsExclusions)
            );
            const minOrderCosts = getMinimumOrderCosts(
                order,
                loggedInUser,
                mandatoryProductSettings,
                productSettingsExclusions
            );
            subtotal += parseFloat(minOrderCosts);
            const shippingCosts = getShippingCosts(order);
            const companyDiscount = getCompanyDiscount(
                order,
                loggedInUser,
                mandatoryProductSettings,
                true,
                productSettingsExclusions
            );
            const orderDiscount = getOrderDiscount(order, productSettingsExclusions);
            const discountCodesAmount = getDiscountCodesAmount(
                order,
                mandatoryProductSettings,
                true,
                productSettingsExclusions
            );

            let manualCosts = 0;
            if (Array.isArray(order.extraCosts)) {
                order.extraCosts.forEach((element) => {
                    if (element.name === null) {
                        manualCosts += parseFloat(element.price);
                    } else if (
                        !element.name.includes("Company discount") &&
                        !element.name.includes("Discount code") &&
                        !element.name.includes("Minimum order amount")
                    ) {
                        manualCosts += parseFloat(element.price);
                    }
                });
            }
            // UPDATE: Remove the manual costs from the subtotal since it was already added there
            // subtotal -= manualCosts;

            if (parseFloat(subtotal) - parseFloat(orderDiscount) - parseFloat(discountCodesAmount) < 0) {
                subtotal = shippingCosts + manualCosts;
            } else if (orderDiscount > 0) {
                subtotal =
                    parseFloat(subtotal) -
                    parseFloat(orderDiscount) +
                    parseFloat(manualCosts) -
                    parseFloat(discountCodesAmount);

                if (subtotal < 0) {
                    subtotal = 0;
                }
                subtotal += parseFloat(shippingCosts);
            } else {
                subtotal =
                    parseFloat(subtotal) +
                    parseFloat(manualCosts) -
                    parseFloat(companyDiscount) -
                    parseFloat(discountCodesAmount);
                if (subtotal < 0) {
                    subtotal = 0;
                }

                // add shipping
                subtotal += parseFloat(shippingCosts);
            }

            return subtotal;
        } else {
            if (typeof deliveryPrice !== "undefined" && deliveryPrice !== null) {
                if (parseFloat(subtotal) - parseFloat(companyDiscount) - parseFloat(totalDiscountCodeAmount) < 0) {
                    subtotal = deliveryPrice;
                } else {
                    subtotal =
                        parseFloat(subtotal) -
                        parseFloat(companyDiscount) -
                        parseFloat(totalDiscountCodeAmount) +
                        parseFloat(deliveryPrice);
                }
            } else {
                subtotal = parseFloat(subtotal) - parseFloat(companyDiscount) - parseFloat(totalDiscountCodeAmount);
            }

            return subtotal;
        }
    };

    // Calculate VAT based on country
    const calcVat = (subtotal, country, company, vatNumber, order) => {
        let subTotalLocal = subtotal;
        if (subTotalLocal < 0) {
            subTotalLocal = 0;
        }

        // Check if order
        if (country === null && order !== null) {
            // Check if country is set in delivery details
            if (typeof order.deliveryDetails !== "undefined" && order.deliveryDetails !== null) {
                country = order.deliveryDetails.country;
            }

            if (typeof order?.delivery_country !== "undefined" && order?.delivery_country !== null) {
                country = order?.delivery_country;
            }

            // Check if status offerte
            if (order.status !== "order" && company !== null && typeof company?.country !== "undefined") {
                country = company.country;
            } else if (company === null && typeof loggedInUser?.user?.country !== "undefined") {
                country = loggedInUser.user.country;
            }
        }

        let vat = 0;
        if (company !== null && typeof country !== "undefined" && country !== null) {
            if (
                (isEU(country) &&
                    vatNumber !== null &&
                    vatNumber !== "" &&
                    vatNumber !== "-" &&
                    country !== "Netherlands") ||
                !isEU(country)
            ) {
                vat = 0;
            } else if (isEU(country)) {
                vat = subTotalLocal * 0.21;
            }
        } else {
            vat = subTotalLocal * 0.21;
        }

        return vat;
    };

    let subt = getSubtotal(
        order,
        loggedInUser,
        mandatoryProductSettings,
        productSettings,
        deliveryPrice,
        subtotal,
        companyDiscount,
        totalDiscountCodeAmount
    );

    let result = calcVat(
        subt,
        country,
        loggedInUser.company,
        typeof loggedInUser?.company !== "undefined" &&
            typeof loggedInUser?.company?.vat_number !== "undefined" &&
            loggedInUser?.company?.vat_number !== ""
            ? loggedInUser.company.vat_number
            : null,
        order
    );

    if (result < 0) {
        result = 0;
    }
    // Check if there is a minimum order amount
    if (
        order?.status === "quotation" &&
        loggedInUser?.company !== null &&
        loggedInUser?.company?.minimum_order_amount !== null &&
        loggedInUser?.company?.minimum_order_amount > subt
    ) {
        let subtotal = getSubtotalPrice(
            order,
            loggedInUser,
            mandatoryProductSettings,
            false,
            productSettingsExclusions
        );
        if (parseFloat(subtotal) < parseFloat(loggedInUser?.company?.price_settings.minimum_order_amount)) {
            // Get the difference between the minimum order amount and the subtotal
            let companyDisc = getCompanyDiscount(
                order,
                loggedInUser,
                mandatoryProductSettings,
                true,
                productSettingsExclusions
            );
            if (companyDisc > 0) {
                let difference = loggedInUser?.company?.price_settings.minimum_order_amount - companyDisc;
                result += difference * 0.21;
            } else {
                let oldVat = subtotal * 0.21;
                result += loggedInUser?.company?.price_settings.minimum_order_amount * 0.21 - oldVat;
            }
        }
    }
    return result;
};

const getMinimumOrderCosts = (order, loggedInUser, mandatoryProductSettings, productSettingsExclusions = []) => {
    if (
        order?.status === "quotation" &&
        loggedInUser?.company !== null &&
        loggedInUser?.company?.price_settings?.minimum_order_amount !== null &&
        loggedInUser?.company?.price_settings?.minimum_order_amount > 0
    ) {
        // Check if the amount is less than the minimum order amount
        let subtotal = getSubtotalPrice(
            order,
            loggedInUser,
            mandatoryProductSettings,
            false,
            productSettingsExclusions
        );
        if (
            loggedInUser.company.minimum_order_amount !== undefined &&
            parseFloat(subtotal) < parseFloat(loggedInUser.company.minimum_order_amount)
        ) {
            // Get the difference between the minimum order amount and the subtotal
            let difference = loggedInUser?.company?.price_settings.minimum_order_amount - subtotal;
            return difference;
        }
    }
    return 0;
};

export {
    getDiscountCodesAmount,
    calculateVat,
    getOrderDiscount,
    getCompanyDiscount,
    getSubtotalPrice,
    getExtraCosts,
    getModelPrice,
    getMinimumOrderCosts,
};
